import { Component, inject, Input } from '@angular/core';
import { MatterMortgage, MortgagePaymentMethods } from '@models/mortgage';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';

import { ICON } from '@core/util/icon';
import { ButtonGroupOption } from 'src/app/shared/atomic/atoms/button-group/button-group.component';
import { onSelectInstitution } from '@components/searchable-fields/lender-search-input-v2/lender-search-input.component';
import { OnSelectBranch } from '@components/searchable-fields/branch-search/branch-search.component';
import { MortgageeType } from '@models/lender';

@Component({
	selector: 'app-mortgage-report',
	templateUrl: './report.component.html',
	styleUrls: ['./report.component.scss'],
	standalone: false,
})
export class LLCReportComponent {
	private matterMortgageDispatch = inject(MatterMortgageDispatch);

	public matterMortgage: MatterMortgage;
	public _matterMortgageId: string;
	public ICON = ICON;

	@Input() mortgage: MatterMortgage;

	public paymentMethodOptions: ButtonGroupOption<MortgagePaymentMethods>[] = [
		{
			label: `Post-Dated Cheque`,
			value: MortgagePaymentMethods.POST_DATED_CHEQUE,
		},
		{
			label: 'Pre-Authorized Debit',
			value: MortgagePaymentMethods.PRE_AUTHORIZED_DEBIT,
		},
		{ label: 'Other', value: MortgagePaymentMethods.OTHER },
	];

	public mortgagePaymentMethods = MortgagePaymentMethods;
	public mortgageeType = MortgageeType;

	updateRegistrationDate($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			registrationDate: $event,
		});
	}

	updateRegistrationNumber($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			registrationNumber: $event,
		});
	}

	setAssignmentOfRents(selected: boolean) {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			assignmentOfRents: selected,
		});
	}

	updateAssignmentOfRentsRegDate($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			assignmentOfRentsRegDate: $event,
		});
	}

	updateAssignmentOfRentsRegNumber($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			assignmentOfRentsRegNumber: $event,
		});
	}

	updateAssignmentOfRentsPpsaRegNumber($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			assignmentOfRentsPpsaRegNumber: $event,
		});
	}

	setShowTermsInReport(selected: boolean) {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			showTermsInReport: !selected,
		});
	}

	setShowActualTermsInReport(selected: boolean) {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			showActualTermsInReport: selected,
		});
	}

	setHideRegistrationFee(selected: boolean) {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			hideRegistrationFee: selected,
		});
	}

	setGeneralSecurityAgreement(selected: boolean) {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			generalSecurityAgreement: selected,
		});
	}

	updateGeneralSecurityAgreementRegDate($event: string) {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			generalSecurityAgreementRegDate: $event,
		});
	}

	updateGeneralSecurityAgreementRegNumber($event: string) {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			generalSecurityAgreementRegNumber: $event,
		});
	}

	updatePaymentMethod($event: MortgagePaymentMethods): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			paymentMethod: $event,
		});
	}

	updatePaymentMethodOther($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			paymentMethodOther: $event,
		});
	}

	updatePaymentMethodNumberOfCheques($event: number): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			paymentMethodNumberOfCheques: $event,
		});
	}

	updatePaymentMethodPayeeName($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			paymentMethodPayeeName: $event,
		});
	}

	updatePaymentMethodAccountNumber($event: string): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			paymentMethodAccountNumber: $event,
		});
	}

	onChangeFinancialInstitution($event: onSelectInstitution): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			paymentMethodFinancialInstitution: $event
				? $event.financialInstitution
				: null,
		});
	}

	onChangeBranch($event: OnSelectBranch): void {
		this.matterMortgageDispatch.updateMortgage(this.mortgage.id, {
			paymentMethodFinancialInstitution: {
				...this.mortgage.paymentMethodFinancialInstitution,
				branch: $event ? $event.branch : null,
			},
		});
	}
}
